import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromStore from '../../../store';
import {catchError, concatMap, debounce, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, of, timer} from 'rxjs';
import { BatteryTestStatusActionTypes, BatteryTestStatusActions } from '../actions/battery-test-status.actions';
import {Store, select, Action} from '@ngrx/store';
import {BatteryService} from '../../../services/battery.service';
import * as featureActions from '../../index';
import {BatteryTestParams} from '../battery-test.model';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';
import {updateInfoType} from '../../../shareModel';


@Injectable()
export class BatteryTestStatusEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private batteryService = inject(BatteryService);

  constructor() {}

  getBatteryTestStatuss$ = createEffect(() => this.actions$.pipe(
    ofType(BatteryTestStatusActionTypes.GetBatteryTestStatuss),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const params: BatteryTestParams = {
        otp: user.otp,
        upsSn: action.payload.upsSn
      };
      return this.batteryService.GetBatteryTestStatus(params).pipe(
        switchMap((res: any) => {
          if (res.result && res.msg.body) {
            //  0: battery test passed
            //  1: waiting for testing
            //  2: battery test failed
            //  3: battery test is never be executed
            const body = { ...res.msg.body, SN: action.payload.upsSn };
            return [new featureActions.LoadBatteryTestStatuss(body)];
          } else {
            return [new featureActions.GetBatteryTestStatussFail()];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetBatteryTestStatussFail());
        })
      );
    })
  ));
  getDelayBatteryTestStatuss$ = createEffect(() => this.actions$.pipe(
    ofType(BatteryTestStatusActionTypes.GetDelayBatteryTestStatuss),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    debounce(() => timer(10000)),
    switchMap(([action, user]: [any, any]) => {
      const params: BatteryTestParams = {
        otp: user.otp,
        upsSn: action.payload.upsSn
      };
      return this.batteryService.GetBatteryTestStatus(params).pipe(
        switchMap((res: any) => {
          if (res.result && res.msg.body) {
            //  0: battery test passed
            //  1: waiting for testing
            //  2: battery test failed
            //  3: battery test is never be executed
            const body = { ...res.msg.body, SN: action.payload.upsSn };
            return [new featureActions.LoadBatteryTestStatuss(body)];
          } else {
            return [new featureActions.GetBatteryTestStatussFail()];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetBatteryTestStatussFail());
        })
      );
    })
  ));
  startBatteryTest$ = createEffect(() => this.actions$.pipe(
    ofType(BatteryTestStatusActionTypes.StartBatteryTest),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const params: BatteryTestParams = {
        otp: user.otp,
        upsSn: action.payload.upsSn,
        WaitingTime: action.payload.WaitingTime,
        from: 1
      };
      return this.batteryService.StartBatteryTest(params).pipe(
        map((res: any) => {
          //  0: battery test executed success (成功指已傳送指令給SW/RMC)
          //  1: battery test was already been executed
          //  2: device need license to execute battery test
          const data = res.msg.body;
          if (data.code === 0 || data.code === 1) {
            return new featureActions.GetBatteryTestStatuss(action.payload);
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const updateRes: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.BatteryTestFail
          };
          return of(new featureActions.GetBatteryTestStatussFail(), new featureActions.UpdateInfoFailAction(updateRes));
        })
      );
    })
  ));




}
